import { render, staticRenderFns } from "./BasicTab.vue?vue&type=template&id=0cebd52c&scoped=true&"
import script from "./BasicTab.vue?vue&type=script&lang=js&"
export * from "./BasicTab.vue?vue&type=script&lang=js&"
import style0 from "./BasicTab.vue?vue&type=style&index=0&id=0cebd52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebd52c",
  null
  
)

export default component.exports